import Store from './Store';

const ArticlesStore = new Store('articles');

export {ArticlesStore};